import { Tooltip, Typography, useTheme } from '@mui/material'
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl'
import DrawIcon from '@mui/icons-material/Draw'
import DetailsIcon from '@mui/icons-material/Details'
import EditIcon from '@mui/icons-material/Edit'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import TimelineIcon from '@mui/icons-material/Timeline'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React from 'react'
import AssigneeAvatars from 'components/DataGrid/components/AssigneeAvatars'
import { User } from 'types'
import StringAvatar from 'components/ui/string-avatar'
import JotformLogo from 'components/ui/jotform-logo'
import GoogleDocsLogo from 'components/ui/google-docs-logo'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import CommentCountIcon from 'components/ui/comment-count-icon'
import { useLocation } from 'react-router-dom'

const TabIcon = ({ title, team_details, count }: { title: string; team_details?: User[]; count?: number | null }) => {
  const theme = useTheme()
  const location = useLocation()
  const titleLower = title?.toLowerCase()
  const base = location.pathname.split('/')[1]
  const boardTheme = base ? theme.palette.icon[base] : 'text.highlight'
  return (
    <Tooltip
      title={['am', 'dms', 'seo', 'integration']?.includes(titleLower) ? '' : <Typography>{title}</Typography>}
      placement={'right'}
      enterDelay={300}
      arrow
    >
      <span>
        {titleLower === 'kickoff call doc' && <GoogleDocsLogo />}
        {titleLower.includes('tier') && <JotformLogo />}
        {titleLower === 'seo' && (
          <>
            {team_details?.length > 0 ? (
              <AssigneeAvatars assignees={team_details} showTooltip={true} />
            ) : (
              <StringAvatar item={{ name: 'SEO' }} />
            )}
          </>
        )}
        {titleLower === 'am' && (
          <>
            {team_details?.length > 0 ? (
              <AssigneeAvatars assignees={team_details} showTooltip={true} />
            ) : (
              <StringAvatar item={{ name: 'AM' }} />
            )}
          </>
        )}
        {titleLower === 'dms' && (
          <>
            {team_details?.length > 0 ? (
              <AssigneeAvatars assignees={team_details} showTooltip={true} />
            ) : (
              <StringAvatar item={{ name: 'DMS' }} />
            )}
          </>
        )}
        {titleLower === 'integration' && (
          <>
            {team_details?.length > 0 ? (
              <AssigneeAvatars assignees={team_details} showTooltip={true} />
            ) : (
              <StringAvatar item={{ name: 'Integration' }} />
            )}
          </>
        )}
        {(titleLower === 'details' || titleLower === 'main') && (
          <DetailsIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
        )}
        {titleLower === 'deals' && (
          <AttachMoneyIcon
            sx={{
              '&:hover': { color: 'text.highlight' },
              color: '#fbc11e',
              height: 22,
              width: 22,
            }}
          />
        )}
        {titleLower === 'checklist' && (
          <ChecklistRtlIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
        )}
        {titleLower === 'description' && (
          <DrawIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
        )}
        {titleLower?.toLowerCase() === 'comments' && (
          <CommentCountIcon
            commentCount={count ?? null}
            boardTheme={boardTheme}
            densityStyles={{ iconSize: 22, badgeFontSize: 12 }}
          />
        )}
        {titleLower === 'timeline' && (
          <TimelineIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
        )}
        {(titleLower === 'edit' || titleLower === 'edit task') && (
          <EditIcon
            sx={{
              color: 'text.warning',
              height: 22,
              width: 22,
            }}
          />
        )}
        {titleLower === 'save' && <CheckCircleOutlineIcon sx={{ color: 'text.success', height: 22, width: 22 }} />}
        {titleLower === 'save chklist' && <FactCheckIcon sx={{ color: 'text.success', height: 22, width: 22 }} />}
        {titleLower === 'cancel' && <DoDisturbIcon sx={{ color: 'text.error', height: 22, width: 22 }} />}
        {(titleLower === 'previous' || titleLower === 'previous task') && (
          <ChevronLeftIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
        )}
        {(titleLower === 'next' || titleLower === 'next task') && (
          <ChevronRightIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
        )}
      </span>
    </Tooltip>
  )
}

export default TabIcon
